import { Component, Input, OnInit } from "@angular/core";
import {
  DisputeCaseBaseDto,
  DisputeDocumentBaseDto,
} from "src/app/shared/models/dispute-resolution/dispute-base-models";

@Component({
  selector: "app-public-view-documents-list",
  templateUrl: "./public-view-documents-list.component.html",
  styleUrls: ["./public-view-documents-list.component.scss"],
  standalone: false,
})
export class PublicViewDocumentsListComponent implements OnInit {
  @Input() disputeCase: DisputeCaseBaseDto;
  @Input() documents: DisputeDocumentBaseDto[] = [];

  displayedColumns: string[] = [
    "title",
    "displayText",
    "createdOn",
  ];

  constructor() { }

  ngOnInit(): void {
    // Component initialization if needed
  }
}
